import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private snackbar: MatSnackBar) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     
    return next.handle(request).pipe( map( event => { 
      if (event instanceof HttpResponse ) {  
        const body = event.body; 
        if (body) {           
           if (!body.response.result[0].success && body.response.result[0].msg) {
            this.snackbar.open(body.response.result[0].msg, 'BELLA+CANVAS', {
                duration: 1000
            });
           } 
        }
      }         
      return event;
    }));
  }

}
